import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CheckoutPaymentModel, ResponseCode_Done } from "../../shared/models/checkout.model";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";
import { WebVoucherService } from "../../services/web_voucher.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { CoreCOMService } from "../../services/com.service";
import Utils from "../../shared/utils";
import { CoreOpenDayTime } from "../../languages/openDayTime";
import { DayOfWeek } from "../../shared/models";
import { UserHelperService } from "../../services/userHelper.service";
import { RemoteOrderGroupPayResultService } from "./remoteOrderGroupPayResult.service";
import { IOrderInfo } from "./remoteOrderGroupPayResult.facade";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";

@Component({
  selector: "remoteOrderGroupPayResult",
  templateUrl: "./remoteOrderGroupPayResult.component.html",
  styleUrls: ["./remoteOrderGroupPayResult.component.scss"],
  providers: [RemoteOrderGroupPayResultService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoteOrderGroupPayResultComponent implements OnInit, OnDestroy {

  public checkoutpaymentmodel: CheckoutPaymentModel;
  public ResponseCode_Done = ResponseCode_Done;
  public webShopMode = WebShopMode;
  public service: WebShopMode;

  public lastOrderInfo: IOrderInfo;
  private _localeChangeSubscription: Subscription;
  private _isWebshopFullyLoadedSubscription: Subscription;
  private _userLoginSubscription: Subscription;

  public confirmationmailtext: string = "";
  public mail: string = "";
  public ordersuccesstext: string = "";
  public phonenumber: string = "";
  public bonuspointsHTMLs: string[] = [];


  public isMobile: boolean = false;
  public get showReturnToHomeBtn(): boolean {
    return this.returnURL.length === 0;
  }
  public get showReturnToURLBtn(): boolean {
    return this.returnURL.length > 0;
  }
  public returnURL: string = "";

  private _groupName: string = "";
  public get groupName(): string {
    return this._groupName;
  }

  constructor(private _remoteOrderGroupPayResultService: RemoteOrderGroupPayResultService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _webShopService: WebShopService
    , public _userHelperService: UserHelperService
    , private _internationalisationService: InternationalisationService
    , private _activatedRoute: ActivatedRoute
    , private _coreCOMService: CoreCOMService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _router: Router) {
  }

  ngOnInit() {
    const me = this;
    me.isMobile = me._coreCOMService.environment.client.isMobile;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["CheckoutPaymentModel"]) {
      me.checkoutpaymentmodel = routeTargetData["CheckoutPaymentModel"];
      me._remoteOrderGroupPayResultService.loadLastOrderInfo().then(async (order) => {
        me.lastOrderInfo = order;
        me._localeChangeSubscription = me._internationalisationService.localeChanged.subscribe(() => {
          me.setLanguageBasedStrings().then();// no wait
        });
        if (me.checkoutpaymentmodel.done === ResponseCode_Done.Authorised) {
          await me._remoteGroupOrderService.setCacheGroupSummary();
          try {
            await me._remoteGroupOrderService.cleanConnectionOnPaymentDone();
          } catch (e) {
            me._coreLogService.error("RemoteOrderGroupPayResultComponent.ngOnInit", "_remoteOrderGroupPayResultService.loadLastOrderInfo", e);
          }
        }
        me._isWebshopFullyLoadedSubscription = me._webShopService.getFullyLoadedObservable.subscribe(async () => {
          const cachesSummaryData = await this._remoteGroupOrderService.getCacheGroupSummary();
          me._groupName = cachesSummaryData.groupName;
          me.service = cachesSummaryData.preOrdervariant;
          me.setLanguageBasedStrings().then();//no wait
          me.PushChanges();
        });
        me.PushChanges();
      }).catch((error) => {
        me._coreLogService.error("RemoteOrderGroupPayResultComponent.ngOnInit", "_remoteOrderGroupPayResultService.loadLastOrderInfo", error);
      });
    } else {
      // No Last Checkoutmodel, Redirect to StartPage and Replace Orderresult in History to make it skipable
      me._router.navigateByUrl("/", { replaceUrl: true, skipLocationChange: true })
      return;
    }
    if (me._userHelperService.IsRegistered) {
      console.log("Result page--> INIT Method");
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
    if (me._isWebshopFullyLoadedSubscription) {
      me._isWebshopFullyLoadedSubscription.unsubscribe();
    }
    if (me._userLoginSubscription) {
      me._userLoginSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGroupPayResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  private async setLanguageBasedStrings() {
    const me = this;
    me.setPhoneNumber();
    me.setMailText();
    await me.setOrderText();
    me.setBonusPoints();
  }

  private setMailText() {
    const me = this;
    if (me.lastOrderInfo) {
      me.mail = me.lastOrderInfo.userEmail;
      me.confirmationmailtext = _.escape(me._coreLanguageService.value("phOrderResult_ConfirmationMailSend_TEXT"))
        .replace("{email}", `<span class="emphasized">${me.mail}</span>`);
    }
  }

  private async setOrderText() {
    const me = this;
    if (this.service && this.lastOrderInfo) {
      const asap = me.lastOrderInfo.serviceDay < 0;
      const hour = Math.floor(this.lastOrderInfo.serviceTime / 10000 % 100);
      const minute = ("00" + Math.floor(this.lastOrderInfo.serviceTime / 100 % 100)).slice(-2);
      let day = "";
      const webshopSetting = await this._webShopService.getWebshopSettingsDataModel();

      if (!asap && webshopSetting.order_day_limit && webshopSetting.order_day_limit > 0) {
        const phOrderResult_DayAtPrefix = this._coreLanguageService.value("phOrderResult_DayAtPrefix");
        const momentorderDate = Utils.GetMomentFromInt(this.lastOrderInfo.serviceDay);
        const dicOpenDayTime = CoreOpenDayTime[InternationalisationService.locale];
        const weekdayName = Utils.EnumName(DayOfWeek, momentorderDate.isoWeekday());
        const phWeekdayName = dicOpenDayTime[`ph${weekdayName}Full`];
        day = ` ${phOrderResult_DayAtPrefix} ${phWeekdayName}, ${momentorderDate.format("DD.MM.YYYY")}`;
      }
      const street = this.lastOrderInfo.street || "";
      const orderid = this.lastOrderInfo.orderid;
      const hasStreet = street.length > 0;
      let placeholder: string;
      if (this.service === WebShopMode.DeliveryGroup) {
        placeholder = hasStreet ? "phOrderResult_SuccessDelivery_BASE" : "phOrderResult_SuccessDelivery_BASE_Nostreet";
      } else {
        placeholder = hasStreet ? "phOrderResult_SuccessPickup_BASE" : "phOrderResult_SuccessPickup_BASE_Nostreet";
      }
      this.setOrderSuccessText(placeholder, orderid, day, hour, minute, street, asap);
      this.PushChanges();
    }
  }

  /**set orderresult text */
  private setOrderSuccessText(placeholder: string, orderid: string, day: string, hour: number, minute: string, street: string = "", asap: boolean) {
    const me = this;
    if (placeholder) {
      let orderText = _.escape(me._coreLanguageService.value(placeholder))
        .replace("{orderid}", `<span class="emphasized">Nr. ${orderid}</span>`);
      const timeAboutPrefix = me._coreLanguageService.value("phOrderResult_TimeAboutPrefix");
      if (asap) {
        // dislay "asap" if the order is for immediate service
        const asapText = me._coreLanguageService.value("phOrderResult_AsSoonAsPossible");
        orderText = orderText.replace("{day}", "")
          .replace("{time}", `<span class="emphasized">${asapText}</span>`);
      } else {
        orderText = orderText.replace("{day}", `<span class="emphasized">${day}</span>`)
          .replace("{time}", `${timeAboutPrefix} <span class="emphasized">${hour}:${minute}</span>`);
      }
      if (street) {
        orderText = orderText.replace("{street}", `<span class="emphasized">${street}</span>`);
      }
      me.ordersuccesstext = orderText;
    } else {
      me.ordersuccesstext = "";
    }
  }

  private async setPhoneNumber() {
    const me = this;
    if (me.lastOrderInfo) {
      me.phonenumber = me.lastOrderInfo.locationPhonenumber;
      me.PushChanges();
    }
  }

  private setBonusPoints() {
    const me = this;
    const bonuspoints = WebVoucherService.parseNewBonusPointsFromBonusPointString(me.checkoutpaymentmodel.BonuspointsVersion, me.checkoutpaymentmodel.BonuspointsForParsing);
    if (bonuspoints) {
      me.bonuspointsHTMLs = bonuspoints.map((bonus) => {
        const pointstext = this._coreLanguageService.value((bonus.points === 1) ? "phOrderResult_Point" : "phOrderResult_Points");
        return _.escape(this._coreLanguageService.value("phOrderResult_CollectedPointsForBonus_BASE"))
          .replace("{points}", `<span class="emphasized">${bonus.points} ${pointstext}</span>`)
          .replace("{bonusaction}", `<span class="emphasized">${bonus.label_de}</span>`);
      });
    }
    me.PushChanges();
  }

  public gotoHome() {
    const me = this;
    me._router.navigate(["/"]);
  }

  public returnToGroupOverview() {
    const me = this;
    me._router.navigate(["/remoteOrderGroupOverview"]);
  }

}
